import clientInfo from 'common/lib/clientInfo';
import { useCallback } from 'react';
import { trackProductAnalytics } from 'common/services/product_analytics';

type TrackingDataType = {
  contentId: string;
  isEdited: boolean;
};
const useTrackDiscardClicked = () => {
  const trackCallback = useCallback(({ contentId, isEdited }: TrackingDataType) => {
    trackProductAnalytics('Course Outline Generator Discard Clicked', {
      'Site ID': clientInfo.get('site_id'),
      'Is Edited': isEdited,
      'Content ID': contentId,
    });
  }, []);

  return trackCallback;
};

export default useTrackDiscardClicked;
